import { Layout } from "antd";
import { Content } from "antd/es/layout/layout";
import styled from "styled-components";

export const StyledLayout = styled(Layout)`
  height: 100vh;
  overflow: hidden;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.neutralLight};
`;

export const StyledContent = styled(Content)`
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  overflow: hidden;
`;
